<form>
  @if(isModal){
  <!-- Modal Header -->
  <div class="modal-header">
    <h4 class="modal-title">{{modalTitle}}</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
  </div>
  }
  <div class="modal-body">
    <ng-container>
      <div class="row">
        @if (sharedService.isAdmin() || sharedService.isBossAccount()) {
        <div class="col-12">
          <div class="block">
            @if (value != undefined || value !== "") {
            <h1 class="badge mt-1" style="font-size: 1.5rem"
              [ngClass]="{ 'bg-success': sharedService.compareResult(compareString, value) == true, 'bg-danger': sharedService.compareResult(compareString, value) == false, 'bg-secondary': compareString === '' }">
              @if (compareString !== "" && sharedService.compareResult(compareString, value) == true) {
              <span>MATCHED</span>
              }
              @if (compareString !== "" && sharedService.compareResult(compareString, value) == false) {
              <span>NOT MATCH</span>
              }
              @if (compareString === "") {
              <span>NOTHING TO COMPARE</span>
              }
            </h1>
            }
          </div>
        </div>
        }

        @if (sharedService.compareResult(compareString, value) != true) {
        <div [ngClass]="needSplitScreen()">
          @if (sharedService.isAdmin() || sharedService.isBossAccount()) {
          <h2>Original</h2>
          }
          <textarea class="auto-grow" id="clipboard-example-textarea" cols="50" rows="30" [(ngModel)]="value"
            name="value" [ngModelOptions]="{ standalone: true }" readonly></textarea>
        </div>
        }
        @if ((sharedService.isAdmin() || sharedService.isBossAccount()) && sharedService.compareResult(compareString,
        value)
        != true) {
        <div class="col-12 col-md-6">
          <h3>Compare</h3>
          <textarea id="clipboard-example-textarea" cols="50" rows="30" [(ngModel)]="compareString"
            compareString="compareString" [ngModelOptions]="{ standalone: true }"
            style="background-color: lightyellow"></textarea>
        </div>
        }
      </div>

      @if (sharedService.compareResult(compareString, value) != true) {
      <button [cdkCopyToClipboard]="value" class="btn btn-info me-2"><i class="far fa-clipboard"></i> Copy to
        clipboard</button>
      <button class="btn btn-success" (click)="generateWhatsappLink()"><i class="fab fa-whatsapp"></i>Whatsapp</button>
      }
    </ng-container>
  </div>

</form>